import { type Guard, type GuardStatus, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useEffect, useState } from 'react';

export const useBaseWCPledgeGuard: Guard = () => {
	const router = useRouter();
	const {
		areSettingsLoading,
		settings: { isWcPledgeEnabled }
	} = useSettings();
	const [status, setStatus] = useState<GuardStatus>('loading');

	const onDenied = () => router.push('/');

	useEffect(() => {
		if (areSettingsLoading) return;

		setStatus(isWcPledgeEnabled ? 'allowed' : 'denied');
	}, [areSettingsLoading, isWcPledgeEnabled]);

	return {
		onDenied,
		status
	};
};
